module.exports = __webpack_public_path__ + "static/media/img_2.f351bd92.png";